import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import dayjs from 'dayjs'
import React from 'react'
import { DatesTopography } from './OnlyPastDatesTopography'
import DateFormat from '../../store/types/enums/DateFormat'

export const ValidDatesTopography = ({ selectedRows }: DatesTopography) => {
  const { t } = useTranslation()

  return (
    <>
      <Typography>{t('page.schedule.deleteManyPopup.deleteConfirmationQuestion')}</Typography>
      <Typography>
        {t('page.schedule.deleteManyPopup.recordsToBeDeleted')} {selectedRows.length}
      </Typography>
      <Box sx={{ display: 'flex', gap: '10px', padding: '36px', flexWrap: 'wrap' }}>
        <Box>
          {selectedRows.map((date, index) => {
            return (
              <Typography key={index} display={'flex'} flexDirection={'column'}>
                {dayjs(date).format(DateFormat.YearMonthDayBracketDayFullName)}
              </Typography>
            )
          })}
        </Box>
      </Box>
    </>
  )
}